import { render, staticRenderFns } from "./TechSet.vue?vue&type=template&id=273dac98&"
import script from "./TechSet.vue?vue&type=script&lang=js&"
export * from "./TechSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports